module.exports = __webpack_public_path__ + "static/tree-235ff99d2b99eca14df4a286950f0476.png";